import styled from 'styled-components';

/** TODO: Color to theme */
export const AppLogoStyled = styled.div`
    /* background-color: ${({ theme }) => theme.branding.primary.main};*/
    background-color: #242e3e;
    color: white;
    ${({ theme }) => theme.mixins.gridColumnCenter};
    padding: 0 20px;
    border-bottom: 1px solid #7a7a7a;
    box-shadow: 0 1px 0 0 rgba(181, 189, 202, 0.2),
        7px 0 15px 0 rgba(69, 90, 100, 0.09);
`;

export const Title = styled.div`
    ${({ theme }) => theme.typography.h5};
    font-weight: 600;
`;
